import React from 'react'
import SEO from '../../Hook/Seo'
import VideoPresentationTelephonie from './TelephonieVideo.mp4'
import TelephoneFixe from '../../components/TelephoneFixe/TelephoneFixe'
import Fixe from './Fixe.png'
import Mobile from './Mobile.png'
import "./telephonie.css"
import { useNavigate } from "react-router-dom";
const Telephonie = () => {
  const navigate = useNavigate();
  return (
    <>

      <SEO
        title="Téléphonie IP entreprise – Standards & SVI | AM Services dans les Vosges"
        description="Installation et gestion de téléphonie IP/VoIP : standards, SVI, DECT, portabilité, formation utilisateurs dans les Vosges."
        path="/telephonie"
        keywords={["téléphonie IP", "VoIP PME", "standard", "SVI", "DECT", "Vosges", "Remiremont", "Épinal , Saint Etienne les Remiremonts , Val D'Ajol , Pouxeux , Arches  "]}
      />
      <div className="container">
        <div className="div_container">
          <h1 className="sr-only">Téléphonie IP d’entreprise : standards, SVI et DECT dans les Vosges</h1>
          <video
            src={VideoPresentationTelephonie}
            autoPlay
            muted
            loop
            playsInline
            className="background-video"
            aria-label="Vidéo de présentation des services AM Services"
          />
          <div className="info-hero-center-text">
          <h1 className="info-title">TÉLÉPHONIE</h1>
          <p className="info-lead">
            Chez AMServices, votre téléphonie professionnelle est simple, fluide et connectée.
          </p>
        </div>
        <div className="scroll-indicator" onClick={() => document.getElementById('game-content-start').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
        </div>
        <div className="divbtnbutton">

        </div>
        <section id="equipement" className='Equipement' >

          {/* <TelephoneFixe /> */}
          <div className="telephonie-choice">

            <div className="choice-card" onClick={() => navigate("/fixe")}>
              <img src={Fixe} />
              <h3>Téléphonie Fixe</h3>
              <p>Postes IP, standards, SVI, installation & support</p>
            </div>

            <div className="choice-card" onClick={() => navigate("/mobile")}>
              <img src={Mobile} alt="Téléphones mobiles" />
              <h3>Téléphonie Mobile</h3>
              <p>Forfaits pros, multi-SIM, data, roaming</p>
            </div>

          </div>
        </section>
      </div>
    </>
  )
}

export default Telephonie